var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 3.3335L10.333 6.00016V3.66683C10.333 3.30016 10.033 3.00016 9.66634 3.00016H5.54634L12.9997 10.4535V3.3335ZM1.17967 0.333496L0.333008 1.18016L2.15301 3.00016H1.66634C1.29967 3.00016 0.999674 3.30016 0.999674 3.66683V10.3335C0.999674 10.7002 1.29967 11.0002 1.66634 11.0002H9.66634C9.80634 11.0002 9.92634 10.9468 10.0263 10.8802L12.153 13.0002L12.9997 12.1535L1.17967 0.333496Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideo);
export default __webpack_public_path__ + "static/media/noVideo.a1b572c19112435d0efa5e7648d824b2.svg";
export { ForwardRef as ReactComponent };